// CategoryDropdown.jsx
import React, { useState, useEffect } from 'react';
import { CustomDropdown } from './Customdropdown'; // Import your CustomDropdown
import styles from "./editandcreate.module.css";

export const CategoryDropdown = ({ 
  value, 
  onChange, 
  categories = [],
  placeholder = "Select category",
  width = '200px',
  disabled = false
}) => {
  const [search, setSearch] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);

  // Set initial search value when value changes
  useEffect(() => {
    if (value && value.name) {
      setSearch(value.name);
    } else {
      setSearch('');
    }
  }, [value]);

  const filteredCategories = categories.filter(category => 
    category.category?.name?.toLowerCase().includes(search.toLowerCase())
  );

  const handleSelect = (category) => {
    onChange(category.category);
    setSearch(category.category.name);
    setShowDropdown(false);
  };

  const handleClearSelection = () => {
    onChange(null);
    setSearch('');
    setShowDropdown(false);
  };

  const handleToggleDropdown = (show) => {
    if (disabled) return;
    setShowDropdown(show);
    // Clear search when opening dropdown to show all options
    if (show) {
      setSearch('');
    }
  };

  return (
    <div className={styles.categoryDropdownWithClear} style={{ width }}>
      <CustomDropdown
        searchValue={search}
        onSearchChange={setSearch}
        showDropdown={showDropdown}
        onToggleDropdown={handleToggleDropdown}
        options={filteredCategories}
        onSelect={handleSelect}
        placeholder={placeholder}
        renderOption={(category) => category.category.name}
        width="100%"
        disabled={disabled}
      />
      {value && (
        <button 
          type="button"
          className={styles.clearCategoryBtn}
          onClick={handleClearSelection}
          disabled={disabled}
          title="Clear selection"
        >
          <i className='pi pi-times'></i>
        </button>
      )}
    </div>
  );
};